<template>
  <!-- Auth redesign — лаконичный переключатель языка (без флагов), полупрозрачный на тёмной панели. -->
  <div class="lang" :class="{ 'on-dark': this.dark }" ref="root">
    <button type="button" class="lang-btn" :aria-expanded="this.open" v-on:click.stop="this.toggle">
      {{ this.lang.shortName ? this.lang.shortName.toUpperCase() : 'EN' }}
      <svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
    </button>
    <div v-if="this.open" class="lang-menu" role="listbox">
      <button type="button" v-for="l in this.langs" :key="l.shortName" class="lang-item" :class="{ sel: l.shortName == this.lang.shortName }" v-on:click="this.select(l)">
        {{ l.localName }}
        <svg v-if="l.shortName == this.lang.shortName" class="tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LanguageSwitcher",
  props: {
    type: [String],
    dark: { type: Boolean, default: true },
  },
  data() {
    return {
      open: false,
      lang: {},
      langs: [
        { shortName: "en", longName: "English", localName: "English" },
        { shortName: "ru", longName: "Russian", localName: "Русский" },
        { shortName: "de", longName: "Deutsch", localName: "Deutsch" },
        { shortName: "fr", longName: "Français", localName: "Français" },
        { shortName: "cs", longName: "Český", localName: "Český" },
        { shortName: "kk", longName: "Қазақша", localName: "Қазақша" },
        { shortName: "pl", longName: "Polski", localName: "Polski" },
        { shortName: "zh", longName: "中文", localName: "中文" },
      ],
    };
  },
  created() {
    let l = this.$store.state.config.LOCALES;
    if (l && l.length > 0) {
      this.langs = l;
    }
    this.getLang();
  },
  mounted() {
    document.addEventListener("mousedown", this.onDoc);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.onDoc);
  },
  methods: {
    toggle() { this.open = !this.open; },
    onDoc(e) {
      if (this.$refs.root && !this.$refs.root.contains(e.target)) this.open = false;
    },
    getLang() {
      this.langs.forEach((e) => {
        if (e.shortName == this.$i18n.locale) this.lang = e;
      });
    },
    select(lang) {
      this.setLocale(lang);
      this.open = false;
    },
    setLocale(lang) {
      this.$i18n.locale = lang.shortName;
      localStorage.setItem("lang", lang.shortName);
      this.lang = lang;
      this.$store.dispatch("reRender");
    },
  },
};
</script>

<style lang="scss" scoped>
.lang { position: relative; }

.lang-btn {
  display: inline-flex; align-items: center; gap: 7px;
  height: 36px; padding: 0 12px;
  border: 1.5px solid var(--line-strong); background: #fff; color: var(--ink);
  border-radius: 10px; cursor: pointer;
  font-family: 'HelveticaNeue', 'Roboto medium', sans-serif; font-size: 13.5px; font-weight: 600;
  transition: background .15s ease, border-color .15s ease;
}
.lang-btn .chev { width: 14px; height: 14px; color: var(--ink-faint); transition: transform .18s ease; }
.lang-btn[aria-expanded="true"] .chev { transform: rotate(180deg); }

/* полупрозрачный вариант на тёмной панели */
.lang.on-dark .lang-btn {
  background: rgba(255, 255, 255, .12);
  border-color: rgba(255, 255, 255, .22);
  color: #fff;
  backdrop-filter: blur(6px);
}
.lang.on-dark .lang-btn:hover { background: rgba(255, 255, 255, .2); border-color: rgba(255, 255, 255, .34); }
.lang.on-dark .lang-btn .chev { color: rgba(255, 255, 255, .75); }

.lang-menu {
  position: absolute; top: calc(100% + 6px); right: 0; min-width: 150px; z-index: 30;
  background: #fff; border: 1px solid var(--line); border-radius: 12px; padding: 6px;
  box-shadow: 0 18px 40px -16px rgba(20, 22, 40, .32), 0 2px 6px rgba(20, 22, 40, .06);
  display: flex; flex-direction: column; gap: 2px;
}
.lang-item {
  display: flex; align-items: center; gap: 10px; padding: 9px 10px; border-radius: 8px;
  font-size: 13.5px; color: var(--ink); cursor: pointer; border: none; background: transparent;
  font-family: inherit; text-align: left; width: 100%;
}
.lang-item:hover { background: #f3f3f6; }
.lang-item .tick { margin-left: auto; width: 15px; height: 15px; color: var(--accent-link); }
.lang-item.sel { color: var(--accent-link); font-weight: 600; }
</style>
